import React from 'react';
import {DropDownMultiSelector} from "./DropDownSelector.jsx";

const idsAndNames = [
	{id:0, name:"NO"},
	{id:1, name:"YES"}
]
export const SelectBool = (props) =>
{
   return(
      <DropDownMultiSelector objects={idsAndNames} selectSingle={true} value={Number(props.value)} onChange={props.onChange}/>
      );
}


// WEBPACK FOOTER //
// ./js/genericElements.jsx